import * as React from 'react';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  useTheme,
  Theme
} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import './PaymentHistorySearchFilter.scss';
import i18n from 'src/translation/i18n';

// });
export const SEARCH_FILTER_MAPPING = {
  'Invoice No': 'Invoice Number',
  'Order No': 'Order Number',
  'Purchase Order No': 'Purchase Order Number'
};
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const names = [
  { text: `${i18n.t('invoices.invoiceNo')}`, val: 'Invoice No' },
  { text: `${i18n.t('invoices.orderNo')}`, val: 'Order No' },
  { text: `${i18n.t('invoices.purchaseOrderNo')}`, val: 'Purchase Order No' }
  // 'Invoice No', 'Order No', 'Purchase Order No'
];
function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium
  };
}

export default function PaymentHistorySearchFilter(props: any) {
  const classes = useStyles();
  const theme = useTheme();
  const [personName, setPersonName] = React.useState<string[]>(['Invoice No']);
  const { isReset, isResetSearch } = props;

  React.useEffect(() => {
    if (isReset || isResetSearch) {
      setPersonName(['Invoice No']);
    }
  }, [isReset, isResetSearch]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setPersonName(event.target.value as string[]);
    let searchValue: any = event.target.value;
    let searchKey: any = SEARCH_FILTER_MAPPING[searchValue];
    props.setFilters(searchKey);
    searchValue = null;
    searchKey = null;
  };
  const { getInvoices } = props;
  // props.setFilters(personName);
  return (
    <div className="Insearch-container">
      <FormControl className={clsx(classes.formControl, classes.noLabel)}>
        <Select
          displayEmpty={true}
          value={personName}
          onChange={handleChange}
          MenuProps={MenuProps}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          {/* <MenuItem value={names[0]}>{names[0]}</MenuItem> */}
          {names.map(name => (
            <MenuItem
              key={name.val}
              value={name.val}
              style={getStyles(name.val, personName, theme)}
            >
              {name.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
